let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("eZ6Dk"), load("eiB8M"), load("8kb9x")]).then(() => parcelRequire('bgk3m'));